<template>
    <div class="my-2 h-[1px] bg-primary-100 dark:bg-dark-500"></div>
</template>
